module.exports = __webpack_public_path__ + "img/chat-attachment-delete.b27d2bf7.svg";